<template>
  <div :id="phone.id" class="list-box-container"
       @mouseup="($_can('phone-numbers.show') ||
         $_can('phone-numbers.view-own'))"
  >
    <template>
      <div class="d-flex list-box-header col-12 pointer">
        <div class="pl-0 list-box-header-left col-lg-7 col-7 pr-3">
          <div class="pl-0 d-flex align-items-center col-7">
            <div class="list-box-status align-items-start col-12">
              <span class="ref-id">
                {{ phoneMask.maskedPhone(phone.phone_number) }}
              </span>
            </div>
          </div>
          <div class="pl-0 d-flex align-items-center col-5">
            <div class="list-box-status align-items-start col-12">
              <span v-if="phone.company">
                {{ phone.company.name }}
              </span>
              <span v-else-if="phone.carrier">
                {{ phone.carrier.name }}
              </span>
              <span v-else>
                -
              </span>
            </div>
          </div>
        </div>
        <div class="list-box-header-right col-lg-5 col-5 pl-4">
          <div class="d-flex align-items-center col-7">
            <div class="phone-phones" v-if="phone.type">
              <span class="management" v-if="phone.type.id === 1">
                {{ phone.type.name }}
              </span>
              <span class="claims-roles" v-if="phone.type.id === 2">
                {{ phone.type.name }}
              </span>
            </div>
            <div class="phone-phones" v-else>
              -
            </div>
          </div>
          <button type="button" class="btn btn-secondary add-filter" id="dropdownMenuButton"
                  @click="$_can('phone-numbers.show') && $emit('openEditModal')"
          />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import PhoneMask from '../../classes/PhoneMask';

export default {
  props: {
    phone: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    phoneMask: new PhoneMask(),
  }),
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.list-box-status {
  align-items: normal;
}
.list-box-header {
  min-height: 66px;
}
.role-roles {
  display: flex;
}
.full-name {
  font-weight: 500;
  font-size: 16px;
  color: #4c5669;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/SettingsPhoneNumbersBlock.vue